import { render, staticRenderFns } from "./kargoTesellumButon.vue?vue&type=template&id=7f8a7218"
import script from "./kargoTesellumButon.vue?vue&type=script&lang=js"
export * from "./kargoTesellumButon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports